export default __webpack_public_path__ + "static/media/seller.639577de.svg";